import { isObject, isDefined } from "@perxis-auto/shared";
import { createListenerMiddleware } from "@reduxjs/toolkit";
import { stagesActions } from "../stages/reducer.js";
import { selectCurrentEntity as selectCurrentEntity$1, selectById } from "../stages/selectors.js";
import { CommonStageIdEnum } from "../stages/types.js";
import { formsActions } from "./reducer.js";
import { selectCurrentEntity } from "./selectors.js";
const listenerMiddleware = createListenerMiddleware();
listenerMiddleware.startListening({
  actionCreator: formsActions.submitForm.pending,
  effect: (action, listenerApi) => {
    const state = listenerApi.getState();
    const currentFormEntity = selectCurrentEntity(state);
    if (!currentFormEntity) {
      return;
    }
    listenerApi.dispatch(
      formsActions.setFormError({
        formId: currentFormEntity.id,
        error: void 0
      })
    );
  }
});
listenerMiddleware.startListening({
  actionCreator: formsActions.submitForm.fulfilled,
  effect: (action, listenerApi) => {
    const state = listenerApi.getState();
    const { result = [] } = action.payload;
    const currentStageEntity = selectCurrentEntity$1(state);
    if (!currentStageEntity) {
      return;
    }
    const nextStage = currentStageEntity.success;
    if (Object.values(CommonStageIdEnum).includes(nextStage)) {
      listenerApi.dispatch(stagesActions.setCurrent(nextStage));
      return;
    }
    const nextStageEntity = selectById(state, nextStage);
    if (!nextStageEntity) {
      return;
    }
    const nextForm = nextStageEntity.form.id;
    const autoCompleteFields = {};
    if (nextStageEntity.autocomplete && Array.isArray(result)) {
      result.forEach((item) => {
        if (isObject(item) && "field_id" in item && "value" in item) {
          autoCompleteFields[item.field_id] = item.value;
        }
      });
    }
    listenerApi.dispatch(
      formsActions.setForm({
        id: nextForm,
        fields: autoCompleteFields
      })
    );
    listenerApi.dispatch(stagesActions.setCurrent(nextStage));
  }
});
listenerMiddleware.startListening({
  actionCreator: formsActions.submitForm.rejected,
  effect: (action, listenerApi) => {
    const state = listenerApi.getState();
    const currentStageEntity = selectCurrentEntity$1(state);
    if (!currentStageEntity || isDefined(currentStageEntity.form.error_message)) {
      return;
    }
    const errorStage = currentStageEntity.error;
    const errorStageEntity = selectById(state, errorStage);
    if (errorStageEntity) {
      const errorForm = errorStageEntity.form.id;
      listenerApi.dispatch(
        formsActions.setForm({
          id: errorForm,
          fields: {}
        })
      );
    }
    listenerApi.dispatch(stagesActions.setCurrent(currentStageEntity.error));
  }
});
const { middleware: formsMiddleware } = listenerMiddleware;
export {
  formsMiddleware
};
